// src/components/TeamMemberCard.js
import React, { useState } from 'react';
import TeamMemberModal from './TeamMemberModal';

const TeamMemberCard = ({ member }) => {
  const [imageError, setImageError] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      {/* Tarjeta compacta */}
      <div className="rounded-xl shadow-lg overflow-hidden transform transition-all duration-300 hover:scale-[1.02] hover:shadow-xl border h-full flex flex-col" style={{ backgroundColor: '#211F1F', borderColor: '#333' }}>
        
        {/* Foto - Mismo tamaño, escala consistente y completamente redonda */}
        <div className="relative w-full flex justify-center items-center pt-6 px-6" style={{ backgroundColor: '#211F1F' }}>
          <div 
            className="w-40 h-40 md:w-48 md:h-48 overflow-hidden rounded-full"
            style={{ 
              backgroundColor: '#211F1F',
              boxShadow: '0 0 0 3px #E8B00C'
            }}
          >
            {!imageError && member.photo ? (
              <img 
                src={member.photo} 
                alt={member.name}
                className="w-full h-full object-cover object-center"
                style={{ 
                  objectPosition: member.name.includes('Evelio') ? 'center 20%' : 'center top'
                }}
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center">
                <div className="text-center text-white p-4">
                  <svg className="w-16 h-16 mx-auto mb-2" style={{ color: '#E8B00C' }} fill="currentColor" viewBox="0 0 24 24">
                    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                  </svg>
                  <p className="text-xs text-gray-400">{member.name}</p>
                </div>
              </div>
            )}
          </div>
        </div>
        
        {/* Información compacta */}
        <div className="p-4 flex-1 flex flex-col">
          <div className="flex justify-between items-start gap-2 mb-1">
            <h4 className="text-base md:text-lg font-bold leading-tight" style={{ color: 'white' }}>
              {member.name}
            </h4>
            <span className="text-xs font-semibold px-2 py-0.5 rounded-full border" style={{ color: '#E8B00C', backgroundColor: '#E8B00C20', borderColor: '#E8B00C30' }}>
              {member.experience}
            </span>
          </div>
          
          <p className="font-semibold text-sm md:text-base mb-1" style={{ color: '#E8B00C' }}>
            {member.position}
          </p>
          <p className="text-gray-400 text-xs md:text-sm mb-3">
            {member.specialty}
          </p>
          
          {/* Descripción corta */}
          <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-4 line-clamp-3">
            {member.description.substring(0, 120)}...
          </p>
          
          {/* Botón ver detalles */}
          <button
            onClick={openModal}
            className="mt-auto w-full py-2 font-semibold rounded-lg transition-all duration-300 text-sm md:text-base"
            style={{ backgroundColor: '#E8B00C', color: '#211F1F' }}
            onMouseEnter={(e) => e.target.style.backgroundColor = '#c49a0a'}
            onMouseLeave={(e) => e.target.style.backgroundColor = '#E8B00C'}
          >
            Ver perfil completo
          </button>
        </div>
      </div>

      {/* Modal con foto circular */}
      <TeamMemberModal member={member} isOpen={isModalOpen} onClose={closeModal} />
    </>
  );
};

export default TeamMemberCard;